import type { Being, BeingState } from '../../../models/Being';
import type { Surroundings } from '../../../models/Surroundings';
import type { IBeingState } from './IBeingState';

export class RestingState implements IBeingState {
    static readonly stateName = 'Resting';

    get allowInterrupt(): boolean {
        return false;
    }

    canEnter(being: Being, _surroundings: Surroundings): boolean {
        return being.restTicks > 0;
    }

    tick(being: Being, _surroundings: Surroundings): BeingState {
        being.restTicks--;
        if (being.restTicks <= 0) return 'Exploring';
        return RestingState.stateName;
    }
}
